export default "__VITE_ASSET__h$vZGf9o__"